export default "__VITE_ASSET__DRKdjxS4__"